<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .container {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(16px);

    > .header {
      &.is-overlay {
        @include mixins.h4();
      }
      &:not(.is-overlay) {
        @include mixins.h3();
      }
    }

    > .items {
      display: grid;

      &.is-overlay {
        grid-template-columns: repeat(3, 1fr);
        @media (max-width: 970px) {
          grid-template-columns: repeat(2, 1fr);
        }

        @media (max-width: 740px) {
          grid-template-columns: repeat(1, 1fr);
        }
        gap: utils.in_rem(8px) utils.in_rem(22px);
      }
      &:not(.is-overlay) {
        grid-template-columns: repeat(2, 1fr);
        gap: utils.in_rem(12px) utils.in_rem(22px);
      }
    }
  }
</style>

<script>
  import ShowMoreButton from "../ShowMoreButton.svelte";
  import { isOverlayStore } from "../stores";
  import Competitor from "./Competitor.svelte";

  export let competitors = [];

  let showingAllItems = false;

  let innerWidth = 0;

  // Shows two rows, regardless of screen size
  $: maxItems = innerWidth < 740 ? 2 : innerWidth < 970 ? 4 : 6;

  $: wrappedCompetitors =
    showingAllItems || !$isOverlayStore
      ? competitors
      : competitors?.slice(0, maxItems);
</script>

<svelte:window bind:innerWidth />

<div class="container">
  <div class="header" class:is-overlay={$isOverlayStore}>Competitors</div>
  <div class="items" class:is-overlay={$isOverlayStore}>
    {#if wrappedCompetitors}
      {#each wrappedCompetitors as item}
        {@const { logo, name, description } = item}
        <Competitor {logo} {name} {description} />
      {/each}
    {/if}
  </div>
  {#if $isOverlayStore && competitors.length > maxItems}
    <ShowMoreButton bind:showingMore={showingAllItems} />
  {/if}
</div>
